'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false, currentValue: _this.props.defaultValue }, _this.topContainer = null, _this.addClass = function () {
      _this.setState({ active: !_this.state.active });
    }, _this.onBodyClick = function (ev) {
      if (_this.topContainer == null) {
        return;
      }
      if (_this.topContainer.contains(ev.target) === false && _this.state.active === true) {
        _this.setState({ active: false });
      }
    }, _this.updateCurrentValue = function (value) {
      var onChange = _this.props.onChange;

      _this.setState({ currentValue: value, active: false });
      if (onChange) {
        onChange(value);
      }
    }, _this.keyEsc = function (e) {
      if (e.keyCode === 27) {
        _this.setState({ active: false });
      }
    }, _this.mapItems = function () {
      return _this.props.data.map(function (option) {
        return _react2.default.createElement(
          'li',
          {
            key: option.name,
            onClick: function onClick() {
              return _this.updateCurrentValue(option);
            },
            role: 'presentation'
          },
          _react2.default.createElement(
            'button',
            {
              className: 'luna-dropdown__action',
              role: 'option',
              'aria-selected': _this.state.currentValue === option
            },
            option.name
          )
        );
      });
    }, _this.onRef = function (ref) {
      _this.topContainer = ref;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dropdown, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.selectedItems && nextProps.selectedItems && this.props.selectedItems.length !== nextProps.selectedItems.length && this.props.input != null) {
        this.props.input.onBlur(nextProps.selectedItems);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.onBodyClick);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.onBodyClick);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { ref: this.onRef },
        _react2.default.createElement(
          'div',
          {
            onKeyDown: this.keyEsc,
            className: (0, _classnames2.default)('luna-dropdown', {
              'is-visible': this.state.active
            })
          },
          _react2.default.createElement(
            'button',
            {
              onClick: this.addClass,
              className: 'luna-dropdown__trigger luna-select',
              'aria-controls': 'dropdown-menu-1',
              'aria-expanded': this.state.active.toString(),
              type: 'button',
              'aria-haspopup': 'true',
              'aria-label': 'Select one from the following options'
            },
            this.state.currentValue ? this.state.currentValue.name : this.props.placeholder
          ),
          _react2.default.createElement(
            'ul',
            {
              className: 'luna-dropdown__menu',
              id: 'dropdown-menu-1',
              role: 'listbox'
            },
            _react.Children.count(this.props.children) > 0 ? this.props.children : this.mapItems()
          )
        )
      );
    }
  }]);

  return Dropdown;
}(_react.Component);

Dropdown.propTypes = {
  placeholder: _propTypes2.default.string,
  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string
  })),
  defaultValue: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  onChange: _propTypes2.default.func
};
Dropdown.defaultProps = {
  placeholder: 'Select'
};
exports.default = Dropdown;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Dropdown/Dropdown.js